import { InformationGroupType } from './information-group-type.enum';

export enum InformationType {
	BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
	CAMPER_AREA = 'CAMPER_AREA',
	CAMPER_TERRAIN = 'CAMPER_TERRAIN',
	CAMPING = 'CAMPING',
	CAMPING_ACCOMMODATION_PARK = 'CAMPING_ACCOMMODATION_PARK',
	GENERIC_ROOMS = 'GENERIC_ROOMS',
	GENERIC_TERRAIN = 'GENERIC_TERRAIN',
	GUEST_ROOM = 'GUEST_ROOM',
	HOLIDAY_ACCOMMODATION = 'HOLIDAY_ACCOMMODATION',
	HOLIDAY_COTTAGE = 'HOLIDAY_COTTAGE',
	HOLIDAY_CENTRE = 'HOLIDAY_CENTRE',
	HOLIDAY_PARK = 'HOLIDAY_PARK',
	HOSTEL = 'HOSTEL',
	HOTEL = 'HOTEL',
	MINI_CAMPING = 'MINI_CAMPING',
	YOUTH_ACCOMMODATION = 'YOUTH_ACCOMMODATION',

	MUSEUM = 'MUSEUM',
	ATTRACTION_OR_ANIMAL_PARK = 'ATTRACTION_OR_ANIMAL_PARK',
	EVENT = 'EVENT',
	EXCURSION_OR_DAY_TRIP = 'EXCURSION_OR_DAY_TRIP',
	FOOD_DRINKS = 'FOOD_DRINKS',
	GUIDED_TOUR = 'GUIDED_TOUR',
	INCENTIVE = 'INCENTIVE',
	NIGHT_LIFE = 'NIGHT_LIFE',
	PLAY = 'PLAY',
	SHOP_OR_MARKET = 'SHOP_OR_MARKET',
	SPA_OR_WELLNESS = 'SPA_OR_WELLNESS',
	SPORT = 'SPORT',

	CEMETERY = 'CEMETERY',
	BOAT = 'BOAT',
	BUILDING = 'BUILDING',
	LOCATION_OR_REGION = 'LOCATION_OR_REGION',
	NATURE = 'NATURE',
	MONUMENT = 'MONUMENT',

	ASSISTANCE = 'ASSISTANCE',
	BANK = 'BANK',
	GUIDE = 'GUIDE',
	MEDICAL_SERVICE = 'MEDICAL_SERVICE',
	PUBLIC_FACILITY = 'PUBLIC_FACILITY',
	RENTING_SERVICE = 'RENTING_SERVICE',
	TOURIST_INFORMATION_CENTRE = 'TOURIST_INFORMATION_CENTRE',
	EMBASSY = 'EMBASSY',
	CONGRESS_CENTRE = 'CONGRESS_CENTRE',
	SERVICE_SUPPLIER = 'SERVICE_SUPPLIER',
	EVENT_LOCATION = 'EVENT_LOCATION',

	NODE_NETWORK = 'NODE_NETWORK',
	CYCLING_ROUTE = 'CYCLING_ROUTE',
	LOOP = 'LOOP',
	THEMATIC_ROUTE = 'THEMATIC_ROUTE',
}

export const INFORMATION_TYPES = [
	{ type: InformationType.HOTEL, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.CAMPING, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.CAMPER_AREA, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.CAMPER_TERRAIN, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.MINI_CAMPING, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.CAMPING_ACCOMMODATION_PARK, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.HOLIDAY_PARK, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.GUEST_ROOM, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.BED_AND_BREAKFAST, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.HOLIDAY_COTTAGE, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.HOLIDAY_ACCOMMODATION, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.HOLIDAY_CENTRE, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.YOUTH_ACCOMMODATION, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.HOSTEL, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.GENERIC_ROOMS, groupType: InformationGroupType.ACCOMMODATION },
	{ type: InformationType.GENERIC_TERRAIN, groupType: InformationGroupType.ACCOMMODATION },

	{ type: InformationType.MUSEUM, groupType: InformationGroupType.ACTIVITY },
	{ type: InformationType.ATTRACTION_OR_ANIMAL_PARK, groupType: InformationGroupType.ACTIVITY },
	{ type: InformationType.EXCURSION_OR_DAY_TRIP, groupType: InformationGroupType.ACTIVITY },
	{ type: InformationType.GUIDED_TOUR, groupType: InformationGroupType.ACTIVITY },
	{ type: InformationType.SPA_OR_WELLNESS, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.PLAY, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.SPORT, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.NIGHT_LIFE, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.SHOP_OR_MARKET, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.EVENT, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.FOOD_DRINKS, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },
	{ type: InformationType.INCENTIVE, groupType: InformationGroupType.ACTIVITY, disable: ['toes', 'ivv'] },

	{ type: InformationType.CEMETERY, groupType: InformationGroupType.POINT_OF_INTEREST },
	{ type: InformationType.BUILDING, groupType: InformationGroupType.POINT_OF_INTEREST },
	{ type: InformationType.LOCATION_OR_REGION, groupType: InformationGroupType.POINT_OF_INTEREST },
	{ type: InformationType.NATURE, groupType: InformationGroupType.POINT_OF_INTEREST },
	{ type: InformationType.MONUMENT, groupType: InformationGroupType.POINT_OF_INTEREST },
	{ type: InformationType.BOAT, groupType: InformationGroupType.POINT_OF_INTEREST },

	{ type: InformationType.ASSISTANCE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.BANK, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.GUIDE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.MEDICAL_SERVICE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.PUBLIC_FACILITY, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.RENTING_SERVICE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.TOURIST_INFORMATION_CENTRE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.EMBASSY, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.CONGRESS_CENTRE, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.SERVICE_SUPPLIER, groupType: InformationGroupType.SERVICE },
	{ type: InformationType.EVENT_LOCATION, groupType: InformationGroupType.SERVICE },

	{ type: InformationType.NODE_NETWORK, groupType: InformationGroupType.ROUTE },
	{ type: InformationType.CYCLING_ROUTE, groupType: InformationGroupType.ROUTE },
	{ type: InformationType.LOOP, groupType: InformationGroupType.ROUTE },
	{ type: InformationType.THEMATIC_ROUTE, groupType: InformationGroupType.ROUTE },
];

export function getInformationTypesFor(groupType: InformationGroupType, application?: 'toes' | 'ivv'): InformationType[] {
	return INFORMATION_TYPES.filter((it) => {
		if (it.groupType === groupType) {
			if (!application || !it.disable) {
				return true;
			}

			return !it.disable.some((d) => d === application);
		}

		return false;
	}).map((it) => it.type);
}

export function getInformationGroupType(type: InformationType): InformationGroupType | null {
	const value = INFORMATION_TYPES.find((it) => it.type === type);

	if (value) {
		return value.groupType;
	}

	return null;
}
